import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { SummarySection } from '@shared/components/SummaryCard/SummarySection';
import { useTranslation } from '@shared/core/i18n/useTranslation';

type AttendanceSummaryProps = {
  isAttending: boolean;
};

export const AttendanceSummary = ({ isAttending }: AttendanceSummaryProps) => {
  const { tq } = useTranslation('eventFormDisplay');

  return (
    <SummarySection title={tq`Attendance`}>
      <TextV2
        typographyVariant="body1"
        color="mono11"
        paddingLeft={4}
      >
        {isAttending ? tq`Attending` : tq`Not Attending`}
      </TextV2>
    </SummarySection>
  );
};
